import type { ReactElement } from 'react';
import React from 'react';

import { Box, Heading } from '@zillow/constellation';

import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';

interface HeroHeadlineProps {
    headerText: string;
    subHeaderText?: string;
}

const HeroHeadline: React.FC<HeroHeadlineProps> = ({
    headerText,
    subHeaderText,
}: HeroHeadlineProps): ReactElement => {
    const { isVisualRefreshEnabled } = useGlobalStoreState();

    return (
        <Box
            sx={{
                width: '100%',
                textAlign: 'center',
                ...(isVisualRefreshEnabled
                    ? {
                          'whiteSpace': 'pre-line',
                          '@media $lg_gte': {
                              textAlign: 'left',
                          },
                      }
                    : {
                          filter: 'drop-shadow(0px 0px 5px #000)',
                      }),
            }}
        >
            <Heading
                level={1}
                fontFamily="serif"
                fontType={{
                    ...(isVisualRefreshEnabled
                        ? { xs: 'h3', md: 'h2', lg: 'h1' }
                        : { xs: 'h4', lg: 'h3' }),
                }}
                fontColor="textWhite"
                marginBottom={{ xs: 'sm', lg: 'lg' }}
            >
                {headerText}
            </Heading>
            {subHeaderText && (
                <Heading
                    level={2}
                    margin="lg"
                    marginBottom="md"
                    fontType="h5"
                    fontColor="textWhite"
                >
                    {subHeaderText}
                </Heading>
            )}
        </Box>
    );
};

HeroHeadline.defaultProps = {
    subHeaderText: undefined,
};

export default HeroHeadline;
